/* eslint-disable react-hooks/exhaustive-deps */
import { ErrorMessage, Field } from 'formik';
import { Col, Form, FormControl, Row, Stack } from 'react-bootstrap';
import { FormLabel, FormStepHeader } from '../../../../../components/forms';
import { StepProps } from './AddEditJokeCategory';

export const JokeCategoryForm = ({
  touched,
  errors,
  readOnly,
  values,
  setFieldValue
}: StepProps) => {
  return (
    <>
      <Row>
        <Col xs={12}>
          <FormStepHeader title="Joke Category Details" showRequiredLegend={!readOnly} />
          <Stack gap={3}>
            <Form.Group
              className="mb-lg-3 mb-1"
              controlId="name"
            >
              <FormLabel required>Name</FormLabel>
              <Field
                name="name"
                type="text"
                as={Form.Control}
                isInvalid={touched.name && !!errors.name}
                aria-required
              />
              <ErrorMessage name="name">
                {(msg) => <FormControl.Feedback type="invalid">{msg}</FormControl.Feedback>}
              </ErrorMessage>
            </Form.Group>
          </Stack>
        </Col>
      </Row>
    </>
  );
};
